<template>
  <footer class="footer-container">
    <!-- 上部分 - 80% 红色区域 -->
    <div class="footer-top wow fadeInUp" data-wow-delay="0.0s">
      <div class="container">
        <div class="footer-content">
          <!-- 联系信息区域 -->
          <div class="contact-info">
            <h3 class="contact-title iconfont">{{ this.$t('FooterBar.title') }}</h3>
            <p class="phone-number">{{ SpgData.call }}</p>
            <p class="email">{{ SpgData.email }}</p>
            <p class="address">
              <span v-for="(item, index) in SpgData.address" :key="index">
                <el-tooltip 
                  effect="light" 
                  :content="
                    $i18n.locale === 'zh-CN' ? item.daaInfo : 
                    $i18n.locale === 'zh-TW' ? item.daaInfoTw : 
                    item.daaInfoEn
                  " 
                  placement="top"
                >
                  <el-button>
                    {{ 
                      $i18n.locale === 'zh-CN' ? item.add : 
                      $i18n.locale === 'zh-TW' ? item.addTw : 
                      item.addEn 
                    }}
                  </el-button>
                </el-tooltip>
                <!-- 除了最后一项，都添加 | 分隔符 -->
                <template v-if="index !== SpgData.address.length - 1">&nbsp;|&nbsp;</template>
              </span>
            </p>
          </div>

          <!-- 菜单列表区域 -->
          <div class="footer-box">
            <div class="footer-menu">
              <h4 class="menu-title">{{ this.$t('FooterBar.menuTitle') }}</h4>
              <ul>
                <li><router-link to="/about" @click.native.prevent="handleMenuClick('about')">{{ this.$t('FooterBar.about') }}</router-link></li>
                <li><router-link to="/corporateCulture" @click.native.prevent="handleMenuClick('corporateCulture')">{{ this.$t('FooterBar.Culture') }}</router-link></li>
                <li><router-link to="/news" @click.native.prevent="handleMenuClick('products')">{{ this.$t('FooterBar.news') }}</router-link></li>
              </ul>
            </div>
            <div class="footer-menu">
              <h4 class="menu-title">{{ this.$t('FooterBar.qxtitle') }}</h4>
                <ul>
                  <li><router-link to="/ProductShowcase/#chaye">{{ this.$t('FooterBar.chaye') }}</router-link>&nbsp;<span style="opacity: .5;">|</span>&nbsp;<router-link to="/ProductShowcase/#chaqi">{{ this.$t('FooterBar.chaqi') }}</router-link></li>
                  <li><router-link to="/ProductShowcase/#chayin">{{ this.$t('FooterBar.chayin') }}</router-link>&nbsp;<span style="opacity: .5;">|</span>&nbsp;<router-link to="/ProductShowcase/#chayan">{{ this.$t('FooterBar.chayan') }}</router-link></li>
                  <li><router-link to="/ProductShowcase/#chacang">{{ this.$t('FooterBar.chacang') }}</router-link></li>
                </ul>
            </div>
            <div class="footer-menu">
              <h4 class="menu-title">{{ this.$t('FooterBar.responsibility') }}</h4>
              <ul>
                <li><router-link to="/socialResponsibility/publicWelfare">{{ this.$t('FooterBar.publicWelfare') }}</router-link></li>
                <li><router-link to="/responsibilityView">{{ this.$t('FooterBar.responsibilityView') }}</router-link></li>
                <!-- <li><router-link to="/waterSourceLocation/source">公益之行</router-link></li>
                <li><router-link to="/waterSourceLocation/plant">社会责任</router-link></li>
                <li><router-link to="/waterSourceLocation/factory">工厂介绍</router-link></li> -->
              </ul>
            </div>
          </div>
          

          <!-- 二维码区域 -->
          <div class="qrcode-group">
            <!-- <div class="qrcode-item" v-for="tiem in QRcode" :key="tiem.name">
              <img :src="tiem.img" :alt="tiem.name" class="qrcode-img">
              <p class="qrcode-desc">{{ tiem.name }}</p>
            </div> -->
            <div class="qrcode-item" v-for="item in QRcode" :key="item.name">
              <!-- 图片链接不变，直接使用 img 字段 -->
              <img :src="item.img" 
                  :alt="$i18n.locale === 'zh-CN' ? item.name : $i18n.locale === 'zh-TW' ? item.nameTw : item.nameEn" 
                  class="qrcode-img">
              <!-- 名称根据当前语言显示对应字段 -->
              <p class="qrcode-desc">
                {{ 
                  $i18n.locale === 'zh-CN' ? item.name : 
                  $i18n.locale === 'zh-TW' ? item.nameTw : 
                  item.nameEn 
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="b-wave"></div>
      <div class="b-navbar-bg"></div>
    </div>

    <!-- 下部分 - 20% 深红色区域 -->
    <div class="footer-bottom">
      <div class="container">
        <div class="copyright-info">
          <p>Copyright © 2025 {{ this.$t('FooterBar.Copyright') }} </p>
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-record">
            鄂ICP备2025102539号
          </a>
          <router-link to="/siteMapView"> {{ this.$t('FooterBar.siteMapView') }}</router-link>
          <router-link v-if="adminLogin.status" to="/login" target="_blank"> {{ this.$t('FooterBar.adminLogin') }}</router-link>
          <a v-if="!adminLogin.status" :href="adminLogin.href" target="_blank"> {{ this.$t('FooterBar.adminLogin') }}</a>
          <a href="http://data.3pg.cn" target="_blank"> {{ $t('FooterBar.goToData') }}</a>
          <a href="http://tea.3pg.cn" target="_blank"> {{ $t('FooterBar.goToTea') }}</a>
          <a href="http://tts.3pg.cn" target="_blank"> {{ $t('FooterBar.goToTts') }}</a>
          <a href="https://www.3pg.cn/SPG-Map.html" target="_blank"> {{ $t('FooterBar.layoutMap') }}</a>
          <router-link to="/ImageUploader" target="_blank"> {{ this.$t('FooterBar.ImageUploader') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar',
  data(){
    return {
      "address": [
        {
          "add": "香港",
          "daaInfo": "香港湾仔区告士打道200号新银集团中心",
          "addTw": "香港",
          "daaInfoTw": "香港灣仔區告士打道200號新銀集團中心",
          "addEn": "Hong Kong",
          "daaInfoEn": "Sun Yin Group Centre, 200 Gloucester Road, Wan Chai District, Hong Kong"
        },
        {
          "add": "深圳",
          "daaInfo": "深圳市福田区中心四路11号嘉里建设广场第三座T3座1402室",
          "addTw": "深圳",
          "daaInfoTw": "深圳市福田區中心四路11號嘉里建設廣場第三座T3座1402室",
          "addEn": "Shenzhen",
          "daaInfoEn": "Room 1402, Tower T3, Kerry Properties Plaza, No. 11 Central 4th Road, Futian District, Shenzhen"
        },
        {
          "add": "北京",
          "daaInfo": "北京市西城区黄寺大街26号院德胜置业1栋1706室",
          "addTw": "北京",
          "daaInfoTw": "北京市西城區黃寺大街26號院德勝置業1棟1706室",
          "addEn": "Beijing",
          "daaInfoEn": "Room 1706, Building 1, Desheng Real Estate, No. 26 Huangsi Street, Xicheng District, Beijing"
        },
        {
          "add": "上海",
          "daaInfo": "上海市浦东新区东方路1988号华南大厦404室",
          "addTw": "上海",
          "daaInfoTw": "上海市浦東新區東方路1988號華南大廈404室",
          "addEn": "Shanghai",
          "daaInfoEn": "Room 404, Huanan Building, No. 1988 Dongfang Road, Pudong New Area, Shanghai"
        },
        {
          "add": "武汉",
          "daaInfo": "武汉市江夏区高新四路武汉光谷电子产业园三期6栋2层01室",
          "addTw": "武漢",
          "daaInfoTw": "武漢市江夏區高新四路武漢光谷電子產業園三期6棟2層01室",
          "addEn": "Wuhan",
          "daaInfoEn": "Room 01, 2nd Floor, Building 6, Phase III of Wuhan Optics Valley Electronics Industrial Park, Gaoxin 4th Road, Jiangxia District, Wuhan"
        },
        {
          "add": "重庆",
          "daaInfo": "重庆市北培区缙云山国家级风景区",
          "addTw": "重慶",
          "daaInfoTw": "重慶市北培區縉雲山國家級風景區",
          "addEn": "Chongqing",
          "daaInfoEn": "Jinyun Mountain National Scenic Area, Beipei District, Chongqing"
        },
        {
          "add": "成都",
          "daaInfo": "成都市金牛区金谷三路68号46号1栋2层附207-210室",
          "addTw": "成都",
          "daaInfoTw": "成都市金牛區金谷三路68號46號1棟2層附207-210室",
          "addEn": "Chengdu",
          "daaInfoEn": "Suite 207-210, 2nd Floor, Building 1, No. 46, 68 Jingu 3rd Road, Jinniu District, Chengdu"
        },
        {
          "add": "荆门",
          "daaInfo": "湖北省荆门市掇刀区响岭路1号三皮罐大厦",
          "addTw": "荊門",
          "daaInfoTw": "湖北省荊門市掇刀區響嶺路1號三皮罐大廈",
          "addEn": "Jingmen",
          "daaInfoEn": "Sanpiguan Building, No. 1 Xiangling Road, Duodao District, Jingmen City, Hubei Province"
        }
      ]
    }
  },
  props: {
    adminLogin:{
      type:Object,
      default:()=>({
        status:false,
        href:'https://www.baidu.com'
      })
    },
    // 传递网站信息
    QRcode: {
      type: Array,
      default: () => ([
        {
          "name": "公众号",
          "img": "https://pic1.imgdb.cn/item/68ca12e0c5157e1a880f5e31.jpg"
        },
        {
          "name": "抖音号",
          "img": "https://pic1.imgdb.cn/item/68ca1789c5157e1a880f9e7a.jpg"
        },
        {
          "name": "视频号",
          "img": "https://pic1.imgdb.cn/item/68ca1385c5157e1a880f6567.jpg"
        },
        {
          "name": "小红号",
          "img": "https://pic1.imgdb.cn/item/68ca28c7c5157e1a8810145a.jpg"
        }
      ])
    },
    SpgData: {
      type: Object,
      default: () => ({ 
        call: "400-610-5555",
        address: "湖北省荆门市掇刀区响岭路1号三皮罐大厦",
        email: "info@3pg.cn"
      })
    }
  },
  methods: {
    /**
     * 处理菜单点击事件
     * 可以根据实际项目需求修改，比如使用vue-router导航
     */
    handleMenuClick(path) {
      // 示例：如果使用vue-router，可以这样导航
      // this.$router.push(`/${path}`)
      console.log(`导航到: ${path}`);
    }
  }
};
</script>

<style scoped>
.footer-container {
  width: 100%;
  color: #ffffff;
  font-family: 'Arial', sans-serif;
  margin-top: 0px;
  /* 确保不超出视口宽度 */
  box-sizing: border-box;
  overflow: hidden;
  background: whitesmoke;
}

/* 上部分样式 */
.footer-top {
  position: relative;
  background-color: #303133;
  padding: 40px 0;
  width: 100%;
  border-top: 4px solid #e60012;
  /* 防止内部元素溢出 */
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  /* padding: 0 20px; 添加内边距防止内容贴边 */
  box-sizing: border-box; /* 确保padding不增加总宽度 */
  position: relative;
  z-index: 1;
}

.footer-content {
  display: flex;
  /* flex-wrap: wrap; */
  justify-content: space-between;
  align-items: flex-start;
  width: 100%; /* 确保内容区占满容器 */
  gap: 20px; /* 增加元素间间距，避免拥挤 */
}

/* 联系信息样式 */
.contact-info {
  flex: 1;
  width: 30%; /* 减小最小宽度，增强响应式 */
  margin: 0; /* 移除固定margin，使用gap控制间距 */
}

.contact-title {
  font-size: 24px;
  margin-bottom: 0px;
  font-weight: 600;
  position: relative;
  padding-bottom: 10px;
  margin-top: 0;
}

.contact-title::before {
  content: "\e84f";
  font-size: 44px;
  vertical-align: middle;
  animation: shake 0.5s ease-in-out infinite;
  display: inline-block;
  white-space: nowrap;
}
  @keyframes shake {
    0%, 100% {
      transform: rotate(0deg); /* 初始和结束位置 */
    }
    25% {
      transform: rotate(-8deg); /* 向左旋转5度 */
    }
    75% {
      transform: rotate(8deg); /* 向右旋转5度 */
    }
  }
.phone-number {
  font-size: clamp(2rem, 5vw, 3rem); /* 使用clamp实现响应式字体大小 */
  margin-bottom: 15px;
  margin-top: 0;
  letter-spacing: 1px;
  font-family: 'RAJDHANIB';
  color: #e60012;
  white-space: nowrap;
}

.email, .address {
  font-size: 14px;
  margin-bottom: 10px;
  opacity: 0.9;
  line-height: 1.6;
  white-space: nowrap;
}

/* 菜单样式 */
.footer-menu {
  flex: 1;
  min-width: 150px; /* 减小最小宽度 */
  width: 33.33%;
  margin-bottom: 30px;
  text-align: left;
  padding-left: 30px;
  box-sizing: border-box;
}

.menu-title {
  font-size: 16px;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-menu li {
  margin-bottom: 12px;
}
.footer-ul {
	display: flex;
	gap: 20px;
}
.footer-menu a {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  opacity: 1;
  transition: all 300ms;
}
.footer-menu a:hover {
  color: #e60012;
  transition: all 300ms;
}

/* 二维码样式 - 核心修改区域 */
.qrcode-group {
  flex: 1;
  width: 30%;
  display: flex;
  justify-content: space-between; /* 平均分配空间 */
  align-items: center; /* 垂直居中对齐 */
  white-space: nowrap; /* 防止换行 */
  box-sizing: border-box; /* 包含内边距和边框 */
  padding-top: 20px;
}
.qrcode-group .qrcode-item:last-child{padding-right: 0;}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1; /* 每个子元素平均分配宽度 */
  margin: 0; /* 移除固定margin，避免影响分布 */
  padding: 0 5px; /* 增加内边距避免内容过挤 */
  box-sizing: border-box;
  width: 33.33%;
}

.qrcode-img {
  width: 95%;
  height: auto;
  background-color: #ffffff;
  padding: 2px;
  border-radius: 4px;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.qrcode-desc {
  font-size: 14px;
  opacity: 0.9;
  text-align: center;
  margin: 0 auto;
}

/* 下部分样式 */
.footer-bottom {
  background-color: #e60012; /* 深一点的红色 */
  padding: 10px 0;
  width: 100%;
  box-sizing: border-box;
}

.copyright-info {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 5px; /* 控制版权信息间距 */
  font-size: 14px;
  opacity: 0.9;
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
.copyright-info a, .copyright-info a span {
	color: white;
	font-size: 14px;
	text-decoration: none;
  transition: all 300ms;
}

.icp-record {
  color: #ffffff;
  text-decoration: none;
  transition: opacity 0.3s ease;
}

.icp-record:hover {
  text-decoration: none;
  opacity: .75;
  transition: all 300ms;
}
.copyright-info a:hover{
  opacity: .75;
  transition: all 300ms;
}
.b-navbar-bg {
	position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 300px;
  background: url(https://www.hongchuangkj.com/img/bg-img@2x.87c84f18.png);
  background-size: 500px auto;
  background-repeat: no-repeat;
  background-position: 47% 20%;
  animation: navbarAni 4s linear infinite;
  z-index: 0;
  /* 防止背景图溢出 */
  background-clip: padding-box;
  box-sizing: border-box;
}

.address span button {
	padding: 0;
	box-sizing: border-box;
	background: none;
	border: none;
	font-size: 14px;
  color: white;
  cursor: text;
}
@keyframes navbarAni {
  0% {
    opacity:.05
  }
  50% {
    opacity:.2
  }
  to {
    opacity:.05
  }
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .footer-content {
    justify-content: center;
    gap: 30px;
  }
  
  .contact-info {
    min-width: 100%;
    text-align: center;
    margin-bottom: 20px;
  }
  
  .contact-title::before {
    margin-right: 10px;
  }
}

@media (max-width: 768px) {
  .footer-top {
    /* padding: 30px 0; */
  }
  
  .footer-menu {
    /* min-width: 45%; */
    text-align: center;
  }
  
  .qrcode-group {
    max-width: 350px;
    padding-top: 10px;
  }
}

@media (max-width: 480px) {
  .footer-menu {
    /* min-width: 100%;  */
  }
  
  .qrcode-item {
    /* width: 45%;  */
  }
  
  .qrcode-img {
    width: 80px;
    height: 80px;
  }
  
  .copyright-info {
    flex-direction: column;
    gap: 5px;
  }
}
.b-wave{
  position: absolute;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 30px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAATCAYAAABmxagtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAW9JREFUeNrsmMFNw0AQRWddAeLIKR2QDqADQgWsK0ioAFJBoIKYCkg6CBUEKkhOHJFL4H9lkDhAYmcde8f2SF9z9CZP/8/uODFUn3J+hjaEfvq+eody9gv5yq38Rhc5gGs06uoXiGMqV0Bv0AqAVj2QchDuoFEAgCKAFtBLbHBcRCA82gM0qPnTW2gKMFkPZAeCTpg1AOIvMPcAs+gkEIAggLnOiJiKEZYCzLaJjycNwXhE20QIQ/RMGz1jux2irngtcGWNpXgzu63TLUmNMDgr1oZgiJ51rWdvj0PwgzgrvNiuDE5JTQMxGFGNR1hyQhjeYEQVjTBvxiG6b5q1IKIORpi+W/JogejaYx7BI6/Ox2Ra5frFVQRioK4YSTeLbplWMVtcIAjG0wQay+kWgVaK0fUMPYXEmAtwhO9B7AWTHeMYV9INjKSbDkdT2eKicsle1DXuwICmEy5lt98Z9v9v8BuGw/+Dl4H/LgLfAgwAO3xmgRIme28AAAAASUVORK5CYII=) repeat-x bottom;
  background-size: 41px auto;
  background-position: 0% bottom;
  animation: wavehuad 1500ms linear infinite;
}
@keyframes wavehuad {
  0%{background-position: 0% bottom;}
  100%{background-position: -40px bottom;}
}
.footer-box {
	width: 40%;
	display: flex;
}
</style>
